module.exports = __webpack_public_path__ + "static/img/home10.69865f84.png";